/* eslint-disable */
import React from "react";
import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";

// Constant
import { ROUTES, COMMON_FEATURES } from "../../../../constants";

// Components
import { asyncComponent } from "../../../../components";
import { ROOT_PAGES } from "../../../../pages";
import Dashboard from "../../../../pages/Dashboard";
import Profile from "../../../../pages/Profile";
import { BulkEmployee, EmployeeList } from "../../../../pages/Employee";
import EmployerList from "../../../../pages/Employer";
import PayrollList from "../../../../pages/Payroll";
import CompanyList from "../../../../pages/Company";
import BillingList from "../../../../pages/Billing";

// Redux
import { REDUX as REDUX_UTIL } from "../../../util";
import * as REDUX_ACTION from "../../../redux/actions";

// Services Library

// Modules

const { MODULE_ROUTE } = ROUTES;

const AsyncNotFoundPage = asyncComponent(() => <ROOT_PAGES.NotFoundPage />);

const { reduxStoreWrapper } = REDUX_UTIL;

const MainRoutes = (props) => {
  const { collapsed } = props;

  return (
    <Routes>
      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.DASHBOARD]}
        // element={<PayrollList col={collapsed}/>}
        element={<Dashboard col={collapsed} />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.PAYROLL_ADVANCE_LIST]}
        element={<PayrollList col={collapsed} />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.COMPANY_LIST]}
        element={<CompanyList col={collapsed} />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.BILLING_LIST]}
        element={<BillingList col={collapsed} />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EMPLOYEE]}
        element={<EmployeeList col={collapsed} />}
      />
      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EMPLOYER]}
        element={<EmployerList col={collapsed} />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.BULK_CREATE_EMPLOYEE]}
        element={<BulkEmployee />}
      />

      <Route
        exact
        path={MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.PROFILE]}
        element={<Profile />}
      />
      <Route element={<AsyncNotFoundPage />} />
    </Routes>
  );
};
export default MainRoutes;